export default {
    login: 'Log In',
    forgot_password: 'Forgot your password?',
    english: 'English',
    german: 'Deutsch',
    french: "Français",
    italian: 'Italiano',
    dutch: 'Nederlands',
    spanish: 'Español',
    portuguese: 'Português',
    english_short: 'EN',
    german_short: 'DE',
    french_short: 'FR',
    italian_short: 'IT',
    dutch_short: 'NL',
    spanish_short: 'ES',
    portuguese_short: 'PT',
    maintenance_mode: 'Our website is currently undergoing scheduled maintenance',

    add_links_to_profiles_events_clubs:'Add links to profiles, events and clubs',
    you_can_add_only_twenty_links: 'You can only add 20 links',
    tiktok_link: 'TikTok',
    x_link: 'X',
    instagram_link:'Instagram',
    jff_link: 'Justforfans',
    enter_your_social_network_handle: 'Enter your {social_network} handle',
    follow: 'Follow',
    message: 'Message',
    message_copied: 'Copied successfully',
    copied_from_clipboard: 'Copied from clipboard',
    reply: "reply",
    copy: "copy",
    delete_for_all: "delete for all",
    now: "NOW!",
    meet_now:"Meet NOW!",
    activate_meet_now: "Activate “NOW!” and show that you are ready to meet.",
    activate_now:"Activate NOW!",
    deactivate_now:"Deactivate NOW!",
    meet_now_mini_text:"Now! stays active for 30 minutes.",
    finished:"Finished?",
    activate_meet_now_n_times:"Activate “NOW!” up to {0} times per day. PRO members may activate without limits.",
    over_now:"...over NOW!",
    headline_or_nickname:"Headline or Nickname",
    meet_now_upgrade_to_pro:"“NOW!” has been activated {0} times today. Upgrade to PRO to reactivate “NOW!” without limits.",

    email: 'Email',
    email_or_username: 'Email or nickname',
    photo: 'Photo',
    password: 'your password',
    stay_logged_in: "Stay logged in?",
    new_to_barebuddy: "New to Buddy?",
    join_now: "Join Now!",
    // what_is_barebuddy: 'What is BareBuddy? Find out more',
    recover_password: 'Recover password',
    reset_password: 'Reset password',
    confirm_password: "Confirm password",
    recover_now: "Recover now",
    create: "Create",
    start: "Start",
    join_modal:{
        become_a_member: "Become a member now and enjoy all the futures.",
        its_quick_and_free: "It's quick and free!",
        already_a_member:"Already a member?",
    },
    age_modal:{
        'age_check' : 'Age Check',
        'contain_sensitive_material':'This page may contain sensitive material.',
        'you_need_eighteen':'You need to be over the age of 18 to continue.',
    },
    passwords: {
        password: 'Passwords must be at least six characters and match the confirmation.',
        reset: 'Your password has been reset!',
        sent: 'If this email is registered, you will receive a recovery link.',
        token: 'This password reset token is invalid.',
        user: "If this email is registered, you will receive a recovery link.",
    },
    welcome: {
      what_next: "What would you like to do next?",
      nickname: "Nick name",
      nickname_description: "Complete your profile now.",
      discover: "Discover BUDDY",
      discover_description: "Chat, Date, Chill, Guide and much more to discover.",
      pro: "Upgrade to Pro",
      pro_description: "Infinity fun with Pro version."
    },
    invalid_credentials: "The user credentials were incorrect.",
    reg: {
        // step1: 'Step 1',
        // step2: 'Step 2',
        // step3: 'Step 3',
        choose_password: 'Choose a password',
        automatic_location: "Automatic location",
        manual_location: "Manual location",
        location_defining: "Location defining...",
        password_looks_good:"Your password is looking good.",
        ready: 'Ready',
        pick_handle: "This is your buddy link:",
        suggestions: 'Suggestions',
        password_description: "your password must be min. 6 characters long",
        handle_already_taken : "This buddy link is already taken",
        handle_available: "buddy link is available",
        handle_description : "Your buddy link helps others to find your profile. You can change it now or later in the settings.",
        pick_nickname: "Write a nick name for your Buddy profile",
        nickname: 'Buddyname',
        birthdate: 'Date of birth',
        next: 'Continue',
        enter_email_address: 'Your email',
        almost_finished: 'Almost Finished...',
        upload_photo: "Upload Photo",
        add_photo_text: 'Add a photo so that\n' +
            'the buddies can see you.',
        i_am_ready: "I'm Ready",
        skip: 'Skip',
        back: 'BACK',
        add_photo: 'Add Photo',
        you_made_it: 'You made it!',
        accept_terms_privacy_text: "By pressing “Continue” I assure that I am 18 years or older and that I have read the {0} and accepted the {1}.",
        accept_terms_privacy_text_barebuddy: "By entering, you agree to our {0} and {1}.",
        terms_of_service: "Terms of Service",
        you_must_be_eighteen: "You must be over 18 years old to enter",
        terms_of_use: "Terms of Use",
        privacy_policy: "Privacy Policy",
        finish: 'Finish',
        cancel: 'Cancel',
        upload: 'Upload',
        welcome_to_bb: 'Welcome to BUDDY',
        where_are_you_located: 'Where are you located?',
        use_current_location: 'Use my current location',
        choose_location_manually: 'Choose location manually',
        lets_go: "Ready",
        human_verification_required: 'Please complete the Captcha-box to continue',
        try_another_photo: "try another photo",
        map: "Map",
        use_gps: "Use GPS",
        gps: "GPS",
        type_address: "Type in your Address"
    },
    links: {
        about_us: 'About Us',
        imprint: 'Imprint',
        support: 'Support',
        terms: 'Terms of Use',
        privacy: 'Privacy Statement',
        billing_support: 'Billing Support',
    },
    profile_preview: 'Profile preview',
    public_gallery: 'Public gallery',
    nearby: 'Nearby',
    recent: 'Recent',
    shuffle: 'Shuffle',
    favorites: 'Favorites',
    favorites_online: 'Favorites online',
    online: 'Online',
    send_photo: "Send Photo",
    send_location: 'Send Location',
    set_location: 'Set Location',
    type_something: 'Type something...',
    all: 'All',
    unread: 'Unread',
    pos_of_total: '{position} of {total}',
    block_user: 'Block user',
    report_user: "Report user",
    user_not_found: 'User not found',
    cancel: 'Cancel',
    online_now: 'Online now',
    away: 'Recently online',
    offline: 'Away',
    about: 'About',
    height: 'Height',
    weight: 'Weight',
    body: 'Body',
    position: 'Position',
    penis: 'Penis',
    hiv: 'Status',
    drugs: 'Chems',
    info: 'Info',
    stats: 'Profile',
    photos: 'Photos',
    settings: 'Settings',
    share: 'Share',

    arrow_scroll_top: 'Scroll top',
    open_mailbox: 'Open mailbox',

    main_my_profile: 'My profile',
    main_all_buddies: 'All Buddies',

    search_results: "Search results",

    about_me: 'About me',
    tags: 'Tags',
    access: 'Access',
    profile_account: 'Account',
    account: 'Account',
    logout: 'Log out',
    preferences: 'Preferences',
    show_age: 'Show age',
    yes: 'Yes',
    no: 'No',
    join: 'Join',
    host: 'Host',
    member: 'Member',
    pending: 'pending',

    view_profile: 'View profile',
    language: 'Language',
    unit_system: 'Unit system',
    metric: 'Metric',
    imperial: 'Imperial',
    reset: 'Reset',
    unblock_users: 'Unblock users',
    delete_my_profile: 'Delete my profile',
    your_profile_picture: 'Profile picture',
    public_pictures: 'Public pictures',
    can_select_count: '{count}/{total}',
    make_photo_private: 'Make photo private',
    make_photo_public: 'Make photo public',
    set_profile_picture: 'Set as profile picture',
    delete_photo: 'Delete photo',
    display_name: 'Nickname',
    display_link : 'Buddy link',
    display_club_link_or_title: 'clublink or title',
    location: 'Location',
    support: 'Support',
    photo_message: 'Photo message',
    distance_away: '{distance} away',
    set_current_location: "Set current location",
    location_message: 'Location message',
    no_users_around: 'There are no Buddies around you',
    no_more_users_around: 'There are no more Buddies around you',
    to_see_members_become_a_member: 'To see more users, please become a member.',
    no_chat_messages: 'Chat history is empty',
    no_more_chat_messages: 'There are no more messages in chat history',
    message_not_delivered: 'not delivered - tap to send again',
    old_password: 'Old password',
    new_password: 'New password',
    new_password_confirmation: 'Repeat password',
    password_modified: 'Your password has been successfully modified',
    wrong_old_password: 'Old password is incorrect',
    save: 'Save',
    are_you_sure_delete_profile: "Are you sure you want to delete your profile?",
    all_users_unblocked: 'All users have been successfully unblocked',
    no_tags: 'add your tags here',
    add_tag: "type a single tag and press Return",

    link_copied: "Link copied",
    main_add_tag: "edit tag",
    main_statistics: "Statistics",
    main_profile_about: "Write here about yourself",
    write_us_help: 'Write us for Help, Suggestions & more',
    automatic_location: 'Automatic detection',
    manual_location: 'Set manual location',
    address: 'Address',
    fail_load_location: 'Failed to access your location. Would you like to indicate your location manually?',
    fail_auto_choose_manual_location: 'Failed to access your location. Please choose your location manually.',
    this_is_profile_picture: 'This is your profile picture',
    sure_delete_conversation: "Delete conversation history?",
    sure_delete_spot: "Delete spot?",
    failed_load_user: "Failed to load user profile",
    please_register: "Please register",
    recover_it: "Recover it", //we talk here about forgotten 'password' on login form
    not_a_member: 'Not a member yet?',
    fail_block_user: 'Failed to block the user',
    user_reported_confirmation: 'Thanks for reporting user. We will review it as soon as possible',
    register_here: "Register Here",
    register_new: "Register new",
    options: {
        body: {
            slim: 'Slim',
            average: 'Average',
            athletic: 'Athletic',
            muscular: 'Muscular',
            stocky: 'Stocky'
        },
        position: {
            top: 'Top',
            more_top: 'More top',
            bottom: 'Bottom',
            more_bottom: 'More Bottom',
            versatile: 'Versatile'
        },
        hiv: {
            positive: 'Positive',
            negative: 'Negative',
            undetectable: 'TasP',
            prep: 'PrEP',
            unknown: 'Unknown'
        },
        drugs: {
            yes: 'Yes',
            no: 'No',
            socially: 'Sometimes',
        }
    },
    Sunday: 'Sunday',
    Monday: 'Monday',
    Tuesday: 'Tuesday',
    Wednesday: 'Wednesday',
    Thursday: 'Thursday',
    Friday: 'Friday',
    Saturday: 'Saturday',
    January: 'January',
    February: 'February',
    March: 'March',
    April: 'April',
    May: 'May',
    June: 'June',
    July: 'July',
    August: 'August',
    September: 'September',
    October: 'October',
    November: 'November',
    December: 'December',
    back: 'Back',
    report_harassment: 'Harassment',
    report_fake: 'Fake',
    report_spam: 'Spam',
    report_under_age: 'Under age',
    report_other: 'Other',
    cookies_message: 'Cookies help us to deliver our services. By using our services, you agree to our use of cookies.',
    learn_more: 'Learn more',
    profile_is_deleted: 'This profile has been deleted',
    crop_photo: 'Edit photo',
    install_pwa_ios_message: 'Install BUDDY on your phone: tap <img src="/assets/img/iphone-share-btn.jpg" style="height: 26px" /> and then <strong>Add to Home Screen</strong>: <img style="height: 30px" src="/assets/img/add-home-screen-en.png" />',
    you_are_offline: 'You seem to be offline',
    show_map: 'Map',
    subscribe_to_newsletter: "Newsletter",
    emails_reminders: 'Email summary',
    daily: 'Daily',
    weekly: 'Weekly',
    monthly: 'Monthly',
    never: 'Never',
    "validation.imageable": 'Unsupported image type. Please upload only JPG, PNG or GIF images.',
    user_blocked_confirmation: 'The user has been blocked',
    search_users: "Nickname",
    sure_delete_event: "Delete this event?",
    sure_delete_club: "Delete this club?",
    joined_to_club: "has joined",
    left_to_club: "has left",


    main_search_users: "buddyname or #tag",

    home: {
        come_inside: 'Come inside',
        content_removal : "Content removal",
        bad_boys_society: "Bad Boys Society",
        create_account: "Create account",
        tagline: "Bad Boys Club",
        fun: "Meet gay men for fun.",
        login: "E-Mail or nickname",
        password: "Password",
        log_in: "Log in",
        remember_me: "Remember me.",
        forgot_password: "Forgot password?",
        new_here: "New here?",
        sign_up: "Sign up",
        bump_landing_title: "the gay party app",

        wants: "Show your kinky side.",
        wants_desc: "Experienced or curious - become part of the BUDDY community and explore your kinks. Send taps and start chatting instantly. Search for hashtags to quickly find kinksters that match with you.<br><br>Kinky dates faster than ever.",

        videos: "Watch & share videos.",
        videos_desc: "Watch loads of hot member videos. Share your prerecorded videos in private chats or show them in your public profile.<br><br>It has never been more fun.",
        
        calendar: "Have fun together.",
        calendar_desc: "Create private classifieds in our calendar. Show other buddies what you want and when you want it. Into more? Organise groups and find new friends.<br><br>Meet kinksters just like you.",

        everywhere: "So…what\'s your kink?",
        everywhere_desc: "Use our uncensored website or download the BUDDY app.<br><br>Join now and try it out!",

        generation: "Welcome to the Buddyverse",
        generation_desc: "We believe that we can serve our community best by making BUDDY accessible to everyone. Unlike other apps, we offer the most useful functions totally free. No limits, no annoying ads. We want to become the best and largest gay app for the kinky and fetish lifestyle. Join now and spread the word.<br><br>More buddies - more fun!",

        sign_up_now: "Join now",

        company: "Company",
        about_us: "About Us",
        blog: "Blog",
        help: "Help",
        support: "Billing Support",

        legal: "Legal",
        privacy: "Privacy Statement",
        terms: "Terms of Use",
        usc: "18 U.S.C. 2257",
        imprint: "Imprint",

        languages: "Languages",
        follow_us: "Follow Us"
    },

    home_old: {
        tagline: "Buddies<br/>&<br/>Benefits",
        easy_raw_free: "MEET MEN ON PREP",
        // responsible_dating: "Responsible bareback dating",
        home_text: `Come inside and meet gay guys near you.
            BUDDY is the first network
            for men on PrEP or TasP.`,
        join_start: "Join now and start dating immediately.",
        get_started: "Get started",
        screen_title1: "Easy.",
        screen_sub1: "On the hunt!",
        screen_text1: "Browse profiles, chat and send your videos with ease.",
        screen_title2: "FUN.",
        screen_sub2: "Pure and natural!",
        screen_text2: "No discussions, no judgement. Save your time. Just chat and meet.",
        screen_title3: "Free.",
        screen_sub3: "Join for free.",
        screen_text3: "Unlimited profile views, messages and pictures. BUDDY lets you have unlimited fun."
    },

    company: "Company",
    legal: "Legal",
    social_media: "Social Media",
    edit_your_photo: "You are beautiful!",
    complete_profile: "Complete my profile",
    add_more_photos: "Add more photos",
    check_out_guys: "Check out the Buddies",
    members_login: "Members log in here",
    change_password: "change password",
    create_your_event_plus: "Create your own event. Click +",
    create_new_event: "Create a new event",
    create_event: "Create event",
    create_your_club_plus: "Create your own club. Click +",
    create_new_club: "Create a new club",
    create_club: "Create club",
    title: 'Title',
    date: 'Date',
    pick_date: 'Pick a date',
    time: 'Time',
    add_event_details: 'Add some details:',
    event_description: 'Event description',
    club_description: 'Description',
    club_description_placeholder: 'What is your club all about?',
    private: 'Private',
    public: 'Public',
    non_commercial: 'non-commercial',
    commercial: 'commercial',
    add_tags_optional: "Add tags (optional):",
    select_address: 'Select address',
    location_details: 'Location details (optional)',
    location_example: '(eg: my flat, venue name)',
    full_address: 'Full address',
    city_only: 'Only city',
    event_choose_photos: 'Choose pictures for your event',
    club_choose_photos: 'Choose pictures for your club',
    display: "display:",
    for_censored_app: "for censored app",
    visible_only_uncensored_website: "visible only on uncensored website",
    preview: 'safe picture',
    preview_picture: "Preview picture",
    for_app_and_buddy_net: 'For app & buddy.net',
    must_be: 'Must be',
    alternative: 'picture (optional)',
    hot: "hot",
    only_for_buddy_net: 'Only for buddy.net',
    can_be: 'Can be',
    submit_event: 'Submit',
    event_address: 'Event address',
    club_address: 'City',
    please_select_preview_picture: 'Please select preview picture',
    set_preview_picture: "Set as preview picture",
    event_successfully_added: 'Your event has been successfully added',
    spot_successfully_added: 'Spot has been successfully added',
    spot_successfully_updated: 'Spot has been successfully updated',
    no_events_around: "No events nearby",
    no_more_event_around: "No more events nearby",
    club_successfully_added: 'Your club has been successfully added',
    no_clubs_around: 'No clubs nearby',
    no_more_club_around: 'No more clubs nearby',
    edit: "Edit",
    recipient_will_not_see_you: "The recipient will not see your real profile.",
    public_videos: 'Public videos',
    send: 'Send',
    event_choose_videos: 'Choose videos for your event',
    club_choose_videos: 'Choose videos for your club',
    delete_video: 'Delete video',
    add_video: "Add video",
    videos: "Videos",
    video: "Video",
    play_video: "Play video",
    video_uploaded_processing: "Your video has been uploaded successfully and is now being processed. We'll notify you as soon as it is ready.",
    video_processed: "Your video is ready to use",
    video_message: "Video message",
    sure_delete_photo: "Delete this photo?",
    sure_delete_video: "Delete this video?",
    too_hot: "Too hot",
    notifications: "Notifications",
    push_notifications: "Push notifications",
    share_buddy_app: "Share BUDDY App",
    moderation: "Moderation",
    help: "Help",
    profile: "Profile",
    faq: "FAQ",
    support_chat: "Support chat",
    click_here_tutorials: "Click here for tutorials",
    send_direct_message: "Send a direct message to us",
    app: "App",
    security: "Security",
    notification_sound: "Notification sound",
    deactivate_my_profile: "Deactivate my profile",
    deactivate_or_delete_my_profile: "Deactivate or delete my profile",
    customize_sharing_links: "Customize sharing links",
    delete_all_sharing_links: "Delete all sharing links",
    delete_all: "Delete all",
    deactivate_account: "Deactivate account",
    taking_break_buddy: "Taking a break from BUDDY?",
    deactivate_text_description: "Deactivate your profile and completely disappear from the radar and search.",
    deactivate: "Deactivate",
    cancel_pro: "Cancel PRO status",
    delete_profile_text_first: "If you want to leave for good, you can also delete your profile. This is permanent and CANNOT be undone.",
    delete_profile_text_second: "You will need to create a new profile when you want to come back. <br /><br />You can always come back. Remember, everybody needs some BUDDY :-)",
    click_here: "click here",
    are_you_sure_deactivate_profile: "Are you sure you want to deactivate your profile?",
    are_you_sure_cancel_pro: "Are you sure you want to deactivate PRO status?",
    inactive_profile: "Inactive profile",
    account_is_deactivated: 'Your lovely BUDDY profile is currently deactivated. <br /> Click "Activate" to come back.',
    activate: "Activate",
    leave: "Leave",
    profile_is_deactivated: "This profile is currently deactivated",
    prep_safer_use: "PrEP, TasP, STD, Safer use",
    information_education: "Information & Education",
    prep_chat: "PrEP Chat",
    channel_prep_questions: "Channel for 1:1 PrEP questions",
    censored_event_title: "***Content Warning***",
    censored_event_description: "***This event may contain sensitive material*** <br /><br />Your media settings are configured to warn you about sensitive material. <br />To view it, you need to change your selection in your safety settings",
    censored_club_title: "***Content Warning***",
    censored_club_description: "***This evclubent may contain sensitive material*** <br /><br />Your media settings are configured to warn you about sensitive material. <br />To view it, you need to change your selection in your safety settings",
    censored_content_warning: 'Your media settings are configured to warn you about sensitive material. <br /><br />To view it, you need to change your selection in your safety settings',
    change_settings: "Change Settings",
    show_more: "Show more ...",
    display_web_view_sensitive_events: "Show sensitive content on website",
    display_sensitive_events: "Show sensitive content in app",
    display_sensitive_clubs: "APP: sensitive clubs",
    display_sensitive_media: "Show explicit media in app",
    display_sensitive_media_web: "Show explicit media on website",
    tiles: "Tiles",
    list: "List",
    filter: "Filter",
    pics: "Pics",
    age: "Age",
    new: "New",
    ok: "OK",
    taps: "Taps",
    visitors: "Visitors",
    visited: "Visited",
    no_visitors: 'No visitors yet',
    no_more_visitors: 'No more visitors',
    no_visited: 'No visits yet',
    no_more_visited: 'No more visits',
    no_taps: "No taps",
    no_more_taps: "No more taps",

    discreet_mode: 'Invisible',
    discreet_mode_on: 'Mask Mode (ON)',
    discreet_mode_off: 'Mask Mode (OFF)',

    hide_profile_completely: 'Hide Profile completely',
    hide_profile_completely_tip: '(only when Invisible is enabled)',
    upgrade_to_pro: 'Upgrade to PRO',
    upgrade_to: 'Upgrade to',
    upgrade_now: 'Upgrade now',
    upgrade: 'Upgrade',
    click_here_to_upgrade: 'Click here to upgrade',
    click_here_to_cancel: 'Click here to cancel',
    pro: 'PRO',
    cancel_pro: 'Cancel PRO',
    thank_you_for_being_a_pro: 'Thank you for being a PRO Buddy',
    successful_pro_upgrade: 'You are now a PRO Buddy!',
    failed_pro_upgrade: 'Oops... Something went wrong',
    we_hope_you_enjoyed_pro: 'We hope you enjoyed Buddy PRO',

    delete_this_message: 'Delete this message?',
    delete: 'Delete',
    removed: 'removed',

    pro_slides_1_title: 'Invisible',
    pro_slides_1_description: 'with Mask Mode',
    pro_slides_2_title: 'Cancel Messages',
    pro_slides_2_description: 'and check if he read<br>your message',
    pro_slides_3_title: 'More Filters',
    pro_slides_4_title: 'Unlimited',
    pro_slides_4_description: 'favorites, blocks, visitors,<br>public pics & vids',
    pro_slides_5_title: 'More Fun',
    pro_slides_5_description: 'watch all videos and pics',

    location_button: 'I shared location. Show me mebers!',
    splash_location_title: 'Location error',
    splash_location_description: 'Please share your location so that we can show you members nearby',
    splash_blocks_title: 'Unlimited blocks',
    splash_blocks_description: 'for unlimited blocks upgrade to',
    splash_favorites_title: 'Unlimited favs',
    splash_favorites_description: 'for unlimited favs upgrade to',
    splash_mask_title: 'Invisible',
    splash_mask_description: 'with Invisible Upgrade to',
    splash_censored_title: 'See more',
    splash_censored_description: 'for unlimited content upgrade to',
    splash_visitors_title: 'who viewed me',
    splash_visitors_description: 'to see all of your visitors upgrade to',
    splash_filters_title: 'More filters',
    splash_filters_description: 'For more filters, upgrade to',
    splash_media_title: 'Unlimited public pics & vids',
    splash_media_description: 'for unlimited pics/vids upgrade to',
    splash_deletemsg_title: 'Delete a message',
    splash_deletemsg_description: 'to delete a message upgrade to',
    splash_change_settings_title: 'Your media settings are configured to warn you about sensitive material.',
    splash_change_settings_description: 'To view it, you need to change your selection in your safety settings.',
    splash_events_title: 'More events',
    splash_events_description: 'For more events, upgrade to',
    splash_clubs_title: 'More clubs',
    splash_clubs_description: 'For more clubs, upgrade to',
    splash_clubs_website_title: 'Allow using website field',
    splash_clubs_website_description: 'If you want to enter the website field, upgrade to',

    //pro_upgrade_message_desktop: 'Subscriptions will automatically renew unless canceled within 24-hours before the end of the current period.<br>Please visit <a href="http://cs.segpay.com">SEGPAYEU.COM</a>, our authorized sales agent.<br>Charges will appear on your credit card statement as <a href="http://cs.segpay.com">SEGPAYEU.COM*BUDDY</a>.',
    //pro_upgrade_message_desktop: 'Subscriptions will automatically renew unless canceled within 24-hours before the end of the current period.',
    pro_upgrade_message: 'Subscriptions will automatically renew unless canceled within 24-hours before the end of the current period.',
    payment_blocked: 'Payment request is in process.',
    you_cant_send_messages_to_this_user: 'You can\'t send messages to this user.',

    create_your_club: 'Create your club',

    events: {
        report: {
            title: 'Report Event',
            wrong_type: 'Wrong category',
            illegal: 'Illegal',
        },
        type: {
            friends: 'Friends',
            fun: 'Date',
            bang: 'Chill',
            club: 'Club',
            guide: 'Guide',
            chemsfriendly: 'chemsfriendly',
            required: 'Please select a category',
        },
        date: {
            today: 'today',
            tomorrow: 'tomorrow',
            pick_date: 'pick a date'
        },
        link_my_profile: 'Link my profile',
        not_found: 'Event not found',
        report_success: 'Thanks for reporting event. We will review it as soon as possible',
        new_event: 'New event',
        new_bang: 'New bang',
        my_events: 'My events',
        publish: 'Publish',
        select_type: 'What type of event would you like to create?',
        about_guide: "public events for everybody (parties, festivals, community)",
        about_fun: "find buddies for private 1:1 activities",
        about_bang: "organize private group events",
        invitation_only_event: "Invitation only (private event)",
        please_add_favourite_buddies_first: "Please add favorite buddies first",
        accept: "Accept",
        decline: "Decline",
        invited: "Invited",
        invite: "Invite",
    },

    clubs: {
        admin: 'Admin',
        invites: 'Invites',
        member: 'Member',
        nearby: 'Nearby',
        hide_club_admin: "Hide club admin",
        more_clubs: 'More clubs',
        report: {
            title: 'Report Club',
            wrong_type: 'Wrong category',
            illegal: 'Illegal',
        },
        type: {
            discover: 'Discover',
            my_clubs: 'My clubs',
            chemsfriendly: 'chemsfriendly',
            required: 'Please select a category',
        },
        date: {
            today: 'today',
            tomorrow: 'tomorrow',
            pick_date: 'pick a date'
        },
        not_found: 'Club not found',
        report_success: 'Thanks for reporting club. We will review it as soon as possible',
        new_club: 'New club',
        my_clubs: 'My clubs',
        publish: 'Publish',
        invitation_only_club: "Invitation only (private club)",
        please_add_favourite_buddies_first: "Please add favorite buddies first",
        accept: "Accept",
        decline: "Decline",
        invited: "Invited",
        invite: "Invite",
    },

    payment: {
        coming_soon: 'Coming soon',
        month: "per month",
        send: "Send",
        thank_you: "Thank you!",
        return_to_buddy: "Return to BUDDY",
        one_month: 'month',
        three_months: 'months',
        twelve_months: 'months',
        your_promotion_code: 'Your promotion code',
        please_select_payment_option: 'Please select payment option.',
        use_promo_code: 'Use a PROmo Code',
        credit_card: 'Credit Card',
        alternative_payments: 'Alternative payments',
        renews_automatically_until_cancelled: 'Renews automatically until cancelled.',
        active_until: 'Your PRO-status is active until',
        one_time: 'one time',
        no_need_to_cancel: "(no need to cancel!)",
        upgrade: {
            one_month: 'Upgrade for 1 Month',
            three_months: 'Upgrade for 3 Months',
            twelve_months: 'Upgrade for 12 Months',
        },
        upgrade_paypal: {
            one_month: 'PayPal for 1 Month',
            three_months: 'PayPal for 3 Months',
            twelve_months: 'PayPal for 12 Months',
        },
        paypal: {
            message: '<p>Please enter your PayPal e-mail address.</p><br /><p>We will send you a PayPal link to <br/> that address.</p><br /> <p>After we received the payment, we will <br/> upgrade your Buddy profile.</p>',
            successMessage: '<p>We have received your upgrade request.</p><br /><p>We will send you a Paypal link shortly.</p><br /><p>After we received the payment, <br/> please allow us some time to perform <br/> your upgrade.</p><br /><p>We do it by hand! ✊🏻💦</p>'
        },
        features: {
            unlock_filters : "Unlock all filters",
            be_invsble: "Be invisible",
            see_all_who_viewed_me: "See all who viewed me",
            remove_messages: "Remove messages",
            make_notes_on_profile: "Make notes on profiles",
            unlimited_favorites: "Unlimited favorites",
            view_hot_medias: "View hot media in app",
            see_if_your_message_has_been_read: "See if your message has been read",
            see_wh_marked_you_favorite: "See who marked you favorite",
            hide_profile_visits: "Hide profile visits"
        }
    },

    uploadVideos: {
        error: {
            lowDuration: 'Video duration should be more than 1 second.',
            highDuration: 'Video duration should be less than 15 min.',
        },
    },

    photoRejectedNotification: 'Your photo has been rejected. Please select a different one.',

    rush: {
        running_for_x_days: 'Running for {days} day(s)',
        stars_and_strips_upgrade: 'Stars and Strips. Upgrade to',
        announce: '<span>Hi Buddies,</span><span>the Buddy builders have created something new for you.</span><span>{0} are small apps within BUDDY, that are useful and fun,</span><span>Have fun and stay curious!</span>',
        how_to: {
            title: 'RUSH - How to...',
            create: 'Create your strip',
            name: 'Give a name to your strip',
            media: 'Select picture or write a text',
            publish: 'Publish your strip and add more content',
        },
        welcome: {
            title: 'Welcome to RUSH',
            story: {
                title: 'Your own story.',
                description: 'Add Photos to your strup and show them to all the buddies.',
            },
            post: {
                title: 'Post every day.',
                description: 'Make the "Rush" last longer and get more applause.',
            },
            applause: {
                title: 'More applause?!',
                description: 'It gives you a bigger preview tile. That means more buddy views!',
            },
            attention: {
                title: 'Attention!',
                description: 'If there is no new pic within 24 hours, your strip disappears. The "Rush" is over.',
            },
        },
    },
    sure_unblock_user: "Unblock this profile?",

    party_on_buddies1: "PARTY ON,",
    party_on_buddies2: "BUDDIES!",
    party_on_text1: "There is something new in the Buddyverse. Check out the new \"Guide\" section in our calendar and find parties and events nearby.",
    party_on_text2: "After two years it's about time we go out again and have fun! Let's support event organisers together and rock the party.",

    are_you_sure_you_want_to_delete_all_sharing_links: "Are you sure that you want to delete all sharing links?",
    all_links_will_be_deactivated: "All links will be deactivated.",
    all_sharing_links_deleted_successfully: "All sharing links was deleted successfully",
    this_is_your_sharing_code: "This is your sharing link (click to copy)",
    share_your_selected_videos: "Share your selected videos with<br>guys who are not on Buddy yet.",
    send_via_whatsapp: "Share via Whatsapp",
    tap_on_the_videos_you_want_to_share: "Tap on the videos you want to share",
    cancel_share: "Cancel",
    share_now: "Share now",
    status:"Status",
    you_need_to_be_a_pro_for_editing:"You need to be a <strong>PRO</strong> for editing",
    expire_at_date:"Expire at date",
    expire_at_time:"Expire at time",
    views_limit:"Views limit",
    you_dont_have_any_links:"You don't have any links",
    link_settings_saved:"Link settings saved",
    can_not_get_sharing_links:"Can not get sharing links",
    copied_to_clipboard: "copied to clipboard",
    share_whatsapp_test: "Here is the link to my video on buddy.net:",
    share_videos: 'Share videos',
    accept_all: 'Accept all',
    no_messages : 'No messages',
    you : 'You',
    has: 'has',
    have: 'have',
    joined: 'joined',
    left: 'left',
    web_push_notifications: 'Web push notifications',
    modal_pro_upgrade_description : 'Enjoy this and many other features if you upgrade to PRO.',
    modal_pro_visit_upgrade_description: 'Hide your visit to this profile with PRO',
    note : "Note",
    note_textarea_placeholder : "Add personal info about this profile...",
    who_marked_me_favorite : "Who marked me favorite"
}
